import { Label } from 'firebaseFunctions/types'

export const mockLabelB: Label = {
}
